import { Space } from "antd";
import { getMonth, getDays } from "./Utilidades/Options";
import { useEffect, useState } from "react";
import moment from "moment-business-days";
import _ from "lodash";
import DashboardLayout from "./DashboardLayout";
import GraficoPagasImpagas, { GraficaViewerData } from "./Graficos/GraficoPagasImpagas";
import useGraficaAPI, { EstadisticaData, EstadisticasEquipo, EstadisticasEquipoFecha, EstadisticasPagasImpagas, EstadisticasRequest } from "./EstadisticasApi/useGraficaAPI";
import GraficoEquipo from "./Graficos/GraficoEquipo";
import useEquiposAPI, { Equipo } from "../equipos/useEquiposAPI";
import GraficoFechaEquipo from "./Graficos/GraficoFechaEquipo";

const now = moment();

const Estadisticas = () => {
    const api = useGraficaAPI();
    const apiEquipos = useEquiposAPI();
    const [identificador, setIdentificador] = useState<number>(0);
    const [year, setYear] = useState<number>(now.year());
    const [equipos, setEquipos] = useState<Equipo[]>();
    const [request, setRequest] = useState<EstadisticasRequest>({
        pagasImpagasYear: year,
        CapturasEquipoId: 1,
        CapturasEquipoYear: year,
        CapturasEquipoMonth: 1,
        FechaEquipoId: 1,
        FechaEquipoYear: year
    });
    const [datosResponse, setDatosResponse] = useState<EstadisticaData>({ pagasImpagasData: [], capturasEquipoData: [], fechaPagasImpagasEquipoData: [] });
    const [dataPagasImpagas, setDataPagasImpagas] = useState<GraficaViewerData[]>([]);
    const [dataEquipo, setDataEquipo] = useState<GraficaViewerData[]>([]);
    const [dataFechaInfraccionEquipo, setDataFechaInfraccionEquipo] = useState<GraficaViewerData[]>([]);
    const getYAxis = (proceso: string) => {
        switch (proceso) {
            case 'PAGASIMPAGAS':
                return [{ name: "Impresas", color: '#0288d1' }, { name: 'Pagadas', color: '#2a9b2a' }, { name: 'Impagas', color: '#db3937' }]
            case 'EQUIPO':
                return [{ name: 'Verificacion', color: '#2a9b2a' }, { name: 'Ilegibles', color: '#db3937' }]
            case 'FECHAPAGASEQUIPO':
                return [{ name: "Pagadas", color: '#2a9b2a' }, { name: "Impresas", color: '#0288d1' }]
            default:
                return []
        }
    }

    const getGraficaViewerData = (yName: string, data: []):GraficaViewerData => {
        return {yName: yName, dataArr: [...data]}
    };

    const formatDataPagasImpagas = (estadisticas?: EstadisticasPagasImpagas[]) => {
        let arrayData: GraficaViewerData[] = [];
        let array = estadisticas;
        let impresasMeses: any = [];
        let pagadasMeses: any = [];
        let impagasMeses: any = [];
        array?.forEach((e: any) => {
            if (e.hasOwnProperty('impresas')) {
                let data = { key: getMonth(e.mes), value: e.impresas };
                impresasMeses.push(data);
            }
            if (e.hasOwnProperty('pagadas')) {
                let data = { key: getMonth(e.mes), value: e.pagadas };
                pagadasMeses.push(data);
            }
            if (e.hasOwnProperty('impagas')) {
                let data = { key: getMonth(e.mes), value: e.impagas };
                impagasMeses.push(data);
            }
        });
        let objImpresas = getGraficaViewerData("Impresas", impresasMeses);
        let objPagadas = getGraficaViewerData("Pagadas", pagadasMeses);
        let objImpagas = getGraficaViewerData("Impagas", impagasMeses);        
        arrayData.push(objImpresas, objPagadas, objImpagas);

        return arrayData;
    };

    const formatDataEquipo = (estadisticas?: EstadisticasEquipo[]) => {
        let arrayData: GraficaViewerData[] = [];
        let array = estadisticas;
        let capturadas: any = [];
        let verificacion: any = [];
        let ilegibles: any = [];
        array?.forEach((e: any) => {
            if (e.hasOwnProperty('totalCapturadas')) {
                let data = { key: e.dia, value: e.totalCapturadas };
                capturadas.push(data);
            }
            if (e.hasOwnProperty('totalProcesoVerificacion')) {
                let data = { key: e.dia, value: e.totalProcesoVerificacion };
                verificacion.push(data);
            }
            if (e.hasOwnProperty('totalIlegibles')) {
                let data = { key: e.dia, value: e.totalIlegibles };
                ilegibles.push(data);
            }
        });
        let objCapturadas = getGraficaViewerData("Capturadas", capturadas);
        let objVerificacion = getGraficaViewerData("Verificacion", verificacion);
        let objIlegibles = getGraficaViewerData("Ilegibles", ilegibles);        
        arrayData.push(objCapturadas, objVerificacion, objIlegibles);

        return arrayData;
    }

    const formatFechaInfraccionEquipo = (estadisticas?: EstadisticasEquipoFecha[]) => {
        let arrayData: GraficaViewerData[] = [];
        let array = estadisticas;
        let impresas: any = [];
        let pagadas: any = [];
        array?.forEach((e: any) => {
            if (e.hasOwnProperty('cantidadTotal')) {
                let data = { key: getMonth(e.mes), value: e.cantidadTotal };
                impresas.push(data);
            }
            if (e.hasOwnProperty('cantidadPagadas')) {
                let data = { key: getMonth(e.mes), value: e.cantidadPagadas.reduce((acc: number, value: { nombre: string, cantidad: number, value: number }) => acc + value.cantidad, 0) };
                pagadas.push(data);
            }
        });
        let objCapturadas = getGraficaViewerData("Impresas", impresas);
        let objPagadas = getGraficaViewerData("Pagadas", pagadas);        
        arrayData.push(objCapturadas, objPagadas);

        return arrayData;
    }

    // Solicitud a la api cuando cambia el estado de la request
    useEffect(() => {
        api.getEstadisticas(request, identificador).then(result => {
            let obj: EstadisticaData = {                
                pagasImpagasData:  result.data?.value.pagasImpagasData,
                capturasEquipoData: result.data?.value.capturasEquipoData,
                fechaPagasImpagasEquipoData: result.data?.value.fechaPagasImpagasEquipoData
            }
            setDatosResponse(obj);
        });
        apiEquipos.list({}).then(result => {
            setEquipos(result.data?.value)
        });        
    }, [request]);

    // Transformación de la respuesta hacia el tipo de datos que espera el Gráfico
    useEffect(() => {
        if (datosResponse.pagasImpagasData != undefined) {
            const data = formatDataPagasImpagas(datosResponse.pagasImpagasData);
            setDataPagasImpagas(data);
        }
        if (datosResponse.capturasEquipoData != undefined) {
            const data = formatDataEquipo(datosResponse.capturasEquipoData);
            setDataEquipo(data);
        }
        if (datosResponse.fechaPagasImpagasEquipoData != undefined) {
            const data = formatFechaInfraccionEquipo(datosResponse.fechaPagasImpagasEquipoData);
            setDataFechaInfraccionEquipo(data);
        }
    }, [datosResponse]);

    const handleChangeGrafico = (identificador:number, data:any) => {
        if(identificador == 1){
            setIdentificador(1);
            setRequest({ ...request, pagasImpagasYear: data });
        }
        if (identificador == 2) {
            setIdentificador(2);
            data.name === "year" ? setRequest({ ...request, CapturasEquipoYear: data.value }) : 
            data.name === "month" ? setRequest({ ...request, CapturasEquipoMonth: data.value }) :
            setRequest({ ...request, CapturasEquipoId: data.value });
        }
        if (identificador == 3) {
            setIdentificador(3);
            data.name === "year" ? setRequest({ ...request, FechaEquipoYear: data.value }) : 
            setRequest({ ...request, FechaEquipoId: data.value });
        }
    }

    return (
        <DashboardLayout title="Dashboard Estadísticas">
            {/* Formulario para gráfico de estadísticas general */}            
            <Space size={20} direction='vertical' style={{ width: '100%' }} >
                <GraficoPagasImpagas
                    title = { `Estadísticas de ${'PAGAS E IMPAGAS'} ${request.pagasImpagasYear}` }
                    xAxis = { moment.monthsShort().map(m => m.toUpperCase()) }
                    yAxis = { getYAxis('PAGASIMPAGAS') }
                    data = { dataPagasImpagas }
                    request = { request }
                    handleChangeGrafico = { handleChangeGrafico }
                    tooltipLabelFormatter = { (label) => `${_.upperFirst(moment(label, "MMM").format("MMMM"))} ${request.pagasImpagasYear}` }
                />
            </Space>

            {/* Formulario para gráfico de estadísticas por Equipo de capturas */}
            <Space size={20} direction='vertical' style={{ width: '100%' }}>
                <GraficoEquipo
                    title = { `Estadísticas mensuales de ${'EQUIPO'} ${request.CapturasEquipoYear}` }
                    xAxis = { getDays(request.CapturasEquipoMonth, request.CapturasEquipoYear) }
                    yAxis = { getYAxis('EQUIPO') }
                    data = { dataEquipo }
                    request = {request}
                    equipos = { equipos }
                    handleChangeGrafico = { handleChangeGrafico }
                    tooltipLabelFormatter = { (label) => `${_.upperFirst(moment(label, "DD").format("DD"))}/${request.CapturasEquipoMonth}/${request.CapturasEquipoYear}` }
                />
            </Space>

            {/* Formulario para gráfico de estadísticas por Equipo de Fecha Infracción y Pagas/Impagas */}            
            <Space size={20} direction='vertical' style={{ width: '100%' }} >
                {/* Gráficos de Fecha Infracción / Pagas por Equipo */}
                <GraficoFechaEquipo
                    title = { `Estadísticas anuales de ${'EQUIPO'} ${request.FechaEquipoYear}` }
                    data = { dataFechaInfraccionEquipo }
                    xAxis = { moment.monthsShort().map(m => m.toUpperCase()) }
                    yAxis = { getYAxis('FECHAPAGASEQUIPO') }
                    request = { request }
                    equipos = { equipos }
                    handleChangeGrafico = { handleChangeGrafico }
                    tooltipLabelFormatter = { (label) => `${_.upperFirst(moment(label, "MMM").format("MMMM"))} ${request.FechaEquipoYear}` }
                />
            </Space>

        </DashboardLayout>
    )
};

export default Estadisticas;